export { PagePostFormComponent as PagePostDetail } from './component';


// WEBPACK FOOTER //
// ./src/pages/post-form/index.tsx